// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dz","pgUseBox":"dz","use-card-wrap":"dA","useCardWrap":"dA","use-box-wrap":"dB","useBoxWrap":"dB"};